 $(document).ready(function(){
    $('.thumbnail-slider').slick({
      // vertical: true,
      // verticalSwiping: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.main-slider',
      dots: false,
      arrows: false,
      focusOnSelect: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    });

    $('.main-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      asNavFor: '.thumbnail-slider',
      adaptiveHeight: true,
      infinite: true,
       prevArrow: `<button type="button" class="slick-prev" aria-label="Previous">
    <svg width="39" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="19.5" cy="20.1665" r="18.85" transform="rotate(180 19.5 20.1665)" fill="white" stroke="#5B4B8A" stroke-width="1.3"/>
      <path d="M14.9081 19.4771C14.5274 19.8578 14.5274 20.4752 14.9081 20.8559L21.113 27.0608C21.4938 27.4416 22.1111 27.4416 22.4918 27.0608C22.8726 26.68 22.8726 26.0627 22.4918 25.6819L16.9764 20.1665L22.4918 14.6511C22.8726 14.2703 22.8726 13.653 22.4918 13.2722C22.1111 12.8915 21.4937 12.8915 21.113 13.2722L14.9081 19.4771ZM15.5977 20.1665L15.5977 19.1915L15.5976 19.1915L15.5976 20.1665L15.5976 21.1415L15.5977 21.1415L15.5977 20.1665Z" fill="#5D5398"/>
    </svg>
  </button>`,
  nextArrow: `<button type="button" class="slick-next" aria-label="Next">
    <svg width="39" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="19.5" cy="20.1665" r="18.85" fill="white" stroke="#5B4B8A" stroke-width="1.3"/>
      <path d="M24.088 20.8559C24.4687 20.4752 24.4687 19.8578 24.088 19.4771L17.8831 13.2722C17.5023 12.8915 16.885 12.8915 16.5042 13.2722C16.1235 13.653 16.1235 14.2703 16.5042 14.6511L22.0197 20.1665L16.5042 25.6819C16.1235 26.0627 16.1235 26.68 16.5042 27.0608C16.885 27.4416 17.5023 27.4416 17.8831 27.0608L24.088 20.8559ZM23.3984 20.1665V21.1415H23.3985V20.1665V19.1915H23.3984V20.1665Z" fill="#5D5398"/>
    </svg>
  </button>`
    });
 $('.review-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
     dots: true,
      fade: false,
      nextArrow: $('.slick-next1'),
     prevArrow: $('.slick-prev1'),
      infinite: true,
    });
      $('.testimonial-slider-flo').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
     prevArrow: `<button type="button" class="slick-prev slick-prevs slick-arrow" aria-label="Previous">
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16.7262" cy="16.4903" r="14.8348" fill="#5D5398" stroke="white" stroke-width="1.97798"/>
                <path d="M12.078 15.7919C11.6918 16.1781 11.6918 16.8043 12.078 17.1905L18.3719 23.4844C18.7581 23.8706 19.3843 23.8706 19.7706 23.4844C20.1568 23.0982 20.1568 22.472 19.7706 22.0858L14.176 16.4912L19.7706 10.8966C20.1568 10.5104 20.1568 9.88422 19.7706 9.498C19.3843 9.11178 18.7581 9.11178 18.3719 9.498L12.078 15.7919ZM12.7774 17.4802C13.3236 17.4802 13.7664 17.0374 13.7664 16.4912C13.7664 15.945 13.3236 15.5022 12.7774 15.5022L12.7774 17.4802ZM12.7773 16.4912L12.7773 17.4802L12.7774 17.4802L12.7774 16.4912L12.7774 15.5022L12.7773 15.5022L12.7773 16.4912Z" fill="white"/>
              </svg>
  </button>`,
  nextArrow: `<button type="button" class="slick-next slick-nexts slick-arrow" aria-label="Next">
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16.2738" cy="16.4904" r="14.8348" transform="rotate(-180 16.2738 16.4904)" fill="#5D5398" stroke="white" stroke-width="1.97798"/>
                <path d="M20.9259 17.1888C21.3121 16.8026 21.3121 16.1764 20.9259 15.7902L14.632 9.49629C14.2458 9.11007 13.6196 9.11007 13.2334 9.49629C12.8471 9.88252 12.8471 10.5087 13.2334 10.8949L18.8279 16.4895L13.2334 22.0841C12.8471 22.4703 12.8471 23.0965 13.2334 23.4827C13.6196 23.8689 14.2458 23.8689 14.632 23.4827L20.9259 17.1888ZM20.2265 15.5005C19.6803 15.5005 19.2375 15.9433 19.2375 16.4895C19.2375 17.0357 19.6803 17.4785 20.2265 17.4785L20.2265 15.5005ZM20.2266 16.4895L20.2266 15.5005L20.2265 15.5005L20.2265 16.4895L20.2265 17.4785L20.2266 17.4785L20.2266 16.4895Z" fill="white"/>
              </svg>
  </button>`,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
             arrows: false,
          }
        }
      ]
    });
  });

document.addEventListener("DOMContentLoaded", function () { 
  let selectedVariantId = '{{ product.selected_or_first_available_variant.id }}';

  document.querySelectorAll('.color-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      // 🔁 Update slider images
      const imageUrl = swatch.getAttribute('data-image');
      updateSlidersWithVariantImage(imageUrl);

      // Remove .active from all swatches
      document.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      // Update selected variant ID and color name
      selectedVariantId = swatch.getAttribute('data-variant-id');
      document.getElementById('selected-color').textContent = swatch.getAttribute('data-color-name');

      console.log("selectedVariantId", selectedVariantId);
      if (window.innerWidth <= 992) {
        const target = document.getElementById('scroll-main-product');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });

  function updateSlidersWithVariantImage(imageUrl) {
    const mainImg = document.querySelector('.main-slider .prod-main-1 img');
    const thumbImg = document.querySelector('.thumbnail-slider .thumb-1 img');

    if (mainImg) {
      // Prevent multiple onload triggers
      mainImg.onload = null;
      mainImg.onload = () => {
        slickGotoSafe(3);
      };
      mainImg.setAttribute('src', imageUrl);
    }

    if (thumbImg) {
      thumbImg.setAttribute('src', imageUrl);
    }
  }

  function slickGotoSafe(index) {
    if ($('.main-slider').hasClass('slick-initialized')) {
      $('.main-slider').slick('slickGoTo', index);
    }
    if ($('.thumbnail-slider').hasClass('slick-initialized')) {
      $('.thumbnail-slider').slick('slickGoTo', index);
    }
  }
});

$(document).on("click", ".faq-question-flo", function () {
  const $clicked = $(this);
  const $answer = $clicked.next(".faq-answer-flo");
  const isActive = $clicked.parent().hasClass("active");

  // Collapse all
  $(".faq-item-flo").removeClass("active");
  $(".faq-answer-flo").slideUp();
  $(".faq-icon .plus").show();
  $(".faq-icon .minus").hide();

  // If not already active, expand this one
  if (!isActive) {
    $clicked.parent().addClass("active");
    $answer.slideDown(); // Show the clicked answer
    $clicked.find(".faq-icon .plus").hide();
    $clicked.find(".faq-icon .minus").show();
  }
});



function bindVideoPlayButtons() {
  const playButtons = document.querySelectorAll('.custom-play-button');
  const videos = document.querySelectorAll('video');

  playButtons.forEach((btn) => {
    // Prevent duplicate listeners
    btn.removeEventListener('click', btn._videoClickHandler);

    // Define the handler
    btn._videoClickHandler = function () {
      // Pause all videos
      videos.forEach(v => {
        v.pause();
        v.controls = false;
      });

      const video = btn.previousElementSibling;
      if (!video) return;

      video.play();
      video.controls = true;

      btn.style.display = 'none';

      video.addEventListener('pause', () => {
        btn.style.display = 'inline-flex';
      }, { once: true });
    };

    btn.addEventListener('click', btn._videoClickHandler);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  bindVideoPlayButtons();

  // Also run again after 1s (e.g. for Slick clones or delayed rendering)
  setTimeout(bindVideoPlayButtons, 1000);
});


document.addEventListener("DOMContentLoaded", function () {
  const atcButton = document.querySelector(".landing_product_info");
  const proBar = document.querySelector(".pro-bar");

  if (!atcButton || !proBar) return;

  // Check if on mobile
  const isMobile = window.innerWidth <= 991;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          proBar.classList.add("active");
        } else {
          proBar.classList.remove("active");
        }
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: isMobile ? "-1000px 0px 0px 0px" : "0px 0px 0px 0px"
      // top | right | bottom | left
    }
  );

  observer.observe(atcButton);
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.review-meta').forEach(meta => {
    meta.addEventListener('click', function (e) {
      e.preventDefault(); // Prevent default anchor scroll

      const colorClass = meta.getAttribute('data-attr');
      const swatch = document.querySelector(`.color-swatch.${colorClass}`);

      if (swatch) {
        swatch.click(); // 🟣 Simulate color swatch click
      }

      // ✅ Then scroll to #scroll-main-product (only on mobile)
   
        const target = document.getElementById('scroll-main-product');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
    
    });
  });
});

             